import React from 'react'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'
import Drraheela from '../../../assets/F_Social_science_Cv/Urdu/Dr raheela CV..pdf'
import DrAntal_Cv from '../../../assets/F_Social_science_Cv/Urdu/DrAntal_Cv.pdf'

const Urdu = () => {
  return (
    <>
    <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Urdu</h2>
   
        <p>Urdu.</p>
      </div>

      <div className="row">

      <TeacherCard
      name='Dr. Raheela Bibi '
      profile_name='Assistant Professor, Department of Urdu'
      intro='Assistant Professor HEC Approved Supervisor Department of Urdu Shaheed Benazir Bhutto Women University Peshawar '
      email=' : dr.raheelabibi@sbbwu.edu.pk '
      cv={Drraheela}
      google='https://www.google.com/'
      linkedin=''

      />
   
      <TeacherCard
      name='Dr. Antal Zia '
      profile_name='Assistant Professor, Department of Urdu'
      intro='Assistant Professor Department of Urdu Shaheed Benazir Bhutto Women University, Peshawar'
      email=': antalzia@sbbwu.edu.pk'
      cv={DrAntal_Cv}
      google='https://www.google.com/'
      linkedin=''

      />
   
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>



      <Footer/>
    </>
  )
}

export default Urdu
